import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import { WidgetGroup } from 'app/providers/bridge-api/dashboard.service';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-widget-group-chooser',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [AppSharedModule],
  templateUrl: './widget-group-chooser.component.html',
  styleUrls: ['./widget-group-chooser.component.scss'],
})
export class WidgetGroupChooserComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() widgetGroups: WidgetGroup[];

  @Output() close = new EventEmitter<string | null>();

  form: UntypedFormGroup;

  ds: DropdownObject[];

  constructor(formBuilder: UntypedFormBuilder) {
    this.form = formBuilder.group({
      id: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.ds = this.widgetGroups.map((wg) => ({ id: wg.id, title: wg.title }));
  }

  onAdd(): void {
    this.close.emit(this.form.controls.id.value);
  }

  onCancel(): void {
    this.close.emit(null);
  }
}
